import mergeDeepRight from 'ramda/src/mergeDeepRight'
import { CAMERA_SELECTED_COLORS, ACCESS_WIRE_TYPES_MAP, ACCESS_TYPE_MAP,
  DOOR_SWING_TYPES, READER_PROTOCOL_TYPES, ACCESS_HEADING_ROTATION_DEGREE } from 'helpers/globals'

export const doorControllerDefaults = {
  color: CAMERA_SELECTED_COLORS['blue'],
  doorIds: [],
  dropLength: 10, // in feet
  enclosure: '',
  expansionIds: [],
  expansionHeadingCounter: ACCESS_HEADING_ROTATION_DEGREE / 2.0,
  headingCounter: 0,
  location: {},
  locked: false,
  notes: '',
  model: {
    text: 'Generic Controller',
    limits: {
      doors: 4,
      readers: 4,
      outputs: 10,
      inputs: 16,
      tampers: 4
    }
  }
}

export const addDoorControllerDefaults = mergeDeepRight(doorControllerDefaults)

export const doorDefaults = {
  color: CAMERA_SELECTED_COLORS['blue'],
  controllerId: null,
  location: {},
  locked: false,
  notes: '',
  // peripherals
  auxiliaryInputs: [],
  auxiliaryOutputs: [],
  contacts: [],
  doorOpeners: [],
  locks: [],
  readers: [],
  rexs: [],
  tampers: []
}

export const addDoorDefaults = mergeDeepRight(doorDefaults)

const TYPE_SPECIFIC_OPTIONS = {
  readers: {
    protocol: READER_PROTOCOL_TYPES[0],
    customType: false
  },
  auxiliaryInputs: {
    customType: false
  }
}

export const getPeripheralDefaults = key => {
  const types = ACCESS_TYPE_MAP[key]
  const options = TYPE_SPECIFIC_OPTIONS[key] || {}

  return {
    type: types && types.length ? types[0] : '',
    wireType: ACCESS_WIRE_TYPES_MAP[key].options[ACCESS_WIRE_TYPES_MAP[key].default],
    wireShielded: key === 'readers',
    ...options
  }
}

export const addPeripheralDefaults = type => mergeDeepRight(getPeripheralDefaults(type))



// WEBPACK FOOTER //
// ./src/helpers/accessControl/defaults.js